import { animate, createTimeline, stagger, createDrawable } from '../../vendor/anime.esm.js';
import { DURATION, EASE, STAGGER, resolveDuration, resolveStagger, BLUR, scrollTrigger } from '../motion-tokens.js';

export const processV1 = (el) => {
    // v1: horizontal steps — Recorrido real: paso → línea → paso → línea...
    const container = el.querySelector('.process-steps-h');
    if (!container) return;

    const steps = container.querySelectorAll('.process-step');
    if (!steps.length) return;

    // CRÍTICO: Fijar estado inicial ANTES de que anime-init haga la sección visible.
    // Sin esto, los conectores del paso 2+ aparecen visibles mientras esperan su turno.
    steps.forEach(step => {
        step.style.opacity = '0';
        step.style.transform = 'scale(0.88) translateY(12px)';
        step.style.filter = 'blur(4px)';
        const conn = step.querySelector('.step-connector');
        if (conn) {
            conn.style.opacity = '0';
            conn.style.transform = 'scaleX(0)';
            conn.style.transformOrigin = 'left center';
        }
    });

    const tl = createTimeline();

    steps.forEach((step, i) => {
        // 1. El paso aparece con bounce ligero
        tl.add(step, {
            opacity:   [0, 1],
            scale:     [0.88, 1],
            translateY:[12, 0],
            filter:    ['blur(4px)', 'blur(0px)'],
            duration:  resolveDuration(DURATION.normal),
            ease:      EASE.snappy,
        });

        // 2. La línea crece desde el paso actual hacia el siguiente (efecto "camino")
        const conn = step.querySelector('.step-connector');
        if (conn) {
            tl.add(conn, {
                opacity:  [0, 1],
                scaleX:   [0, 1],
                duration: resolveDuration(DURATION.normal * 0.65),
                ease:     'easeInOutSine',
            }, `-=${resolveDuration(DURATION.normal * 0.15)}`);
        }
    });

    return tl;
};

export const processV2 = (el) => {
    // v2: zigzag SVG — PRIMARIO: SVG stroke se dibuja con createDrawable al scroll.
    // Migrado del IntersectionObserver nativo al onScroll de Anime.js.
    const svgPaths = el.querySelectorAll('svg path, svg line, svg polyline');
    const items    = el.querySelectorAll('.pz-item');
    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    // Primario: SVG se dibuja con scroll sync
    svgPaths.forEach((path) => {
        try {
            const drawable = createDrawable(path);
            if (drawable) {
                animate(drawable, {
                    draw:    ['0 0', '0 1'],
                    duration: resolveDuration(DURATION.slow * 2),
                    ease:    'linear',
                    autoplay: scrollTrigger(el),
                });
            }
        } catch(e) { /* path sin stroke — skip */ }
    });

    // Secundario: cards aparecen alternando izq/der (zigzag)
    // CSS usa .pz-item.active para opacity/transform, así que añadimos la clase
    if (items.length) {
        items.forEach((item, i) => {
            const card = item.querySelector('.pz-card');
            if (card) {
                animate(card, {
                    opacity:    [0, 1],
                    translateX: [i % 2 === 0 ? -30 : 30, 0],
                    filter:     ['blur(3px)', 'blur(0px)'],
                    delay:      i * resolveStagger(STAGGER.slow),
                    duration:   resolveDuration(DURATION.slow),
                    onBegin: () => { item.classList.add('active'); },
                });
            }
        });
    }

    return tl;
};

export const processV3 = (el) => {
    // v3: cards + progress bar — PRIMARIO: barra se llena al scroll (sync).
    // SECUNDARIO: cards entran con stagger cuando la barra las alcanza.
    const bar   = el.querySelector('.process-bar, .progress-bar, [class*="progress"]');
    const cards = el.querySelectorAll('.process-card, .process-step, .step-item');

    // Estado inicial forzado (antes de anime-init)
    if (bar) { bar.style.opacity = '0.5'; bar.style.transform = 'scaleX(0)'; bar.style.transformOrigin = 'left center'; }
    cards.forEach(c => { c.style.opacity = '0'; c.style.transform = 'translateY(25px) scale(0.95)'; c.style.filter = 'blur(3px)'; });

    // Primario: barra de progreso sincronizada con el scroll
    if (bar) {
        animate(bar, {
            scaleX:          [0, 1],
            opacity:         [0.5, 1],
            duration:        resolveDuration(DURATION.slow * 2),
            ease:            'linear',
            transformOrigin: 'left center',
            autoplay:        scrollTrigger(el),
        });
    }

    // Secundario: cards aparecen con stagger
    if (cards.length) {
        animate(cards, {
            opacity:    [0, 1],
            translateY: [25, 0],
            scale:      [0.95, 1],
            filter:     ['blur(3px)', 'blur(0px)'],
            delay:      stagger(resolveStagger(STAGGER.normal)),
            duration:   resolveDuration(DURATION.slow),
            ease:       EASE.snappy,
        });
    }

    return null; // Las dos animaciones corren independientes (no hay timeline común)
};
